import { Link } from "react-router-dom";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function NavLinks() {
  var myGames = (
    <li className="nav_item">
      <Link className="nav_link" to="/my-games/games-today">
        My Games Dashboard
      </Link>
    </li>
  );
  return (
    <ul className="nav_table nav_table--sub">
      <li className="nav_item">
        <Link className="nav_link" to="/tournaments">
          <span className="hidden--mobile">
            View
            {" "}
          </span>

          <span>
            Tournaments
          </span>
        </Link>
      </li>

      {myGames}
    </ul>
  );
});
